/**
 * Authoritative max-win multipliers, sourced from the official
 * Rectangle Games asset manifests (web-rectangle-games repo).
 *
 * The lobby aggregator API (/lobby-available-games) returns max-win
 * values that are stale or wrong for some titles, so we override them
 * here by game code. normalizeGame() applies this map. Games not listed
 * fall back to the (correctly parsed) API value.
 * Generated from manifests on 2026-07-10. 12 of 57 differed from the API.
 */
const MAX_WIN_OVERRIDES = {
  'aquarius-fortune-wheel': 10000,  // was 1000 in API
  'aries-reactor-of-fortune': 10000,
  'aztecs-mystery': 10000,
  'battleship': 2500,  // was 10000 in API
  'black-assassin': 5000,
  'capricorns-orb-of-fortune': 10000,
  'disco-fever': 1000,
  'eggy-pop': 5000,
  'farmageddon': 10000,
  'fiesta-blue': 1000,
  'fiesta-green': 1000,
  'fiesta-magenta': 1000,
  'fiesta-red': 1000,
  'firecrackers-fortune': 5000,  // was 10000 in API
  'firecrackers-fortune-100': 10000,
  'firecrackers-fortune-2': 50000,  // was 5000 in API
  'fortune-pig': 5000,
  'gold-diggers': 10000,
  'golden-koi-trail': 5000,  // was 10000 in API
  'inmate-outcuss': 10000,
  'iron-valor': 5000,  // was 500000 in API
  'jeweled-guardian-1000': 10000,
  'lucky-caramelo-1000': 10000,
  'lucky-caramelo-2': 5000,
  'lucky-duck': 2500,
  'lucky-fox': 2500,
  'lucky-panda': 2500,
  'lucky-snake': 2500,
  'lucky-turtle': 2500,
  'magic-circus': 1000,
  'money-mania': 2000,
  'mystic-tiger-1000': 50000,
  'pirates-treasure-reel': 10000,
  'pirates-treasure-reel-2': 50000,  // was 10000 in API
  'pisces-realm-of-fortune': 10000,
  'prism-riches': 10000,
  'prosperity-dragon': 2500,
  'prosperity-dragon-golden-reel': 5000,  // was 2500 in API
  'prosperity-horse': 5000,  // was 10000 in API
  'prosperity-mouse': 1000,
  'prosperity-ox': 2000,
  'prosperity-rabbit': 5000,
  'prosperity-tiger': 2500,
  'realm-of-thunder': 5000,
  'realm-of-thunder-2': 50000,
  'rudolphs-gift': 10000,
  'shapes-of-fortune': 10000,
  'shapes-of-fortune-xmas': 10000,
  'smash-fury': 5000,
  'solar-pong': 1000,
  'super-lucky-caramelo': 50000,  // was 5000 in API
  'swaggy-caramelo': 5000,
  'swaggy-caramelo-super': 50000,
  'the-lone-fireball': 1000,
  'the-lucky-year': 8888,  // was 500000 in API
  'tinkering-box': 10000,
  'galactic-gold-rush': 8100,  // was 25000 in API — certified cap is 8,100x
  // Official game sheet (Rectangle Game_Game List & Data…xlsx) says x1,250.
  // The API reports 2500, which we shipped in Aug flagged as unverified.
  'skeleton-jewels': 1250,  // was 2500 in API — sheet says x1,250
  'treasures-of-hades': 3000,  // was 2000 in API
  'treasures-of-hades-2': 50000,
  'wheel-of-wealth': 5000,
  'year-of-the-golden-horse': 5000,
};

export default MAX_WIN_OVERRIDES;
